import {detailField} from "../../../data/DetailField";
import React, {useEffect, useState} from "react";
import {styled} from "@mui/system";
import {
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
    tooltipClasses,
    Typography
} from "@mui/material";
import Box from "@mui/material/Box";
import TextFieldValidation from "../table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import ButtonCreate from "../button/ButtonCreate";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";

const SelcoFileFieldsModal = ({open, onClose, handleSubmit, initValue, loading}) => {
    const detailFieldData = Object.entries(detailField)
    const [formState, setFormState] = useState({fields: detailFieldData[0][0], separator: ""});
    const [currentField, setCurrentField] = useState(null)
    const [resultData, setResultData] = useState({
        "fields": [],
        "separators": {}
    })
    const [error, setError] = useState(false)

    useEffect(() => {
        if (initValue) {
            setResultData(initValue)
            setCurrentField(0)
        }
    }, [open]);

    const handleClose = () => {
        onClose()
        setFormState({fields: detailFieldData[0][0], separator: ""})
        setResultData({
            "fields": [],
            "separators": {}
        })
        setError(false)
        setCurrentField(null)
    }
    const handleAdd = () => {
        const separatorAtTheEnd = resultData.separators[resultData.fields.length - 1]

        if (separatorAtTheEnd && separatorAtTheEnd !== " ") {
            setError(true)
        } else {
            handleSubmit(resultData, handleClose)
        }
    }

    const addField = () => {
        setResultData(prev => ({...prev, "fields": [...prev.fields, formState.fields]}))
        setCurrentField(resultData.fields.length)
        setError(false)
    }

    const addSeparator = () => {
        setResultData(prev => ({...prev, "separators": {...prev.separators, [currentField]: formState.separator}}))
        setFormState(prev => ({...prev, separator: ""}))
        setError(false)
    }

    const handleClick = (i) => {
        setCurrentField(i)
    }

    const handleDelete = (i) => {
        const editedData = Object.assign({}, resultData);
        const editedFields = editedData.fields.filter((e, index) => {
            return i !== index
        })
        delete editedData.separators[i]

        if (i < editedData.fields.length) {
            const separators = Object.fromEntries(Object.entries(editedData.separators).map(([key, value]) => {
                return key > i ? [key - 1, value] : [key, value]
            }))
            setResultData({...editedData, fields: editedFields, separators: separators})
        } else {
            setResultData({...editedData, fields: editedFields})
        }

        if (currentField > i || (currentField === i && i !== 0)) setCurrentField(currentField - 1)
        if (editedData.fields.length === 0) setCurrentField(null)
    }

    const CustomWidthTooltip = styled(({className, ...props}) => (
        <Tooltip {...props} classes={{popper: className}}/>
    ))({
        [`& .${tooltipClasses.tooltip}`]: {
            maxWidth: 250,
        },
    });

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "700px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">Порядок экспорта полей Selco</DialogTitle>
            <DialogContent sx={{padding: "0 24px", minWidth: "350px"}}>
                <Box sx={{display: "flex", gap: "20px", alignItems: "center"}}>
                    <Box sx={{width: "292px"}}>
                        <TextFieldValidation
                            select
                            name={"fields"}
                            value={formState.fields}
                            label="Поля"
                            setCurrValues={setFormState}
                            height={60}
                        >{detailFieldData.map((option) => (
                            <MenuItem key={option[0]} value={option[0]}>
                                {option[1]}
                            </MenuItem>))}</TextFieldValidation>
                    </Box>
                    <ButtonCreate
                        text={"Добавить поле"}
                        width={170}
                        height={40}
                        onClick={addField}
                    />
                </Box>
                <Box sx={{display: "flex", gap: "20px", alignItems: "center"}}>
                    <TextFieldValidation
                        name={"separator"}
                        value={formState?.separator}
                        label="Разделитель"
                        setCurrValues={setFormState}
                        height={60}
                    />
                    <ButtonCreate
                        text={"Добавить разделитель"}
                        width={230}
                        height={40}
                        onClick={addSeparator}
                        disabled={currentField === null}
                    />
                    <CustomWidthTooltip
                        sx={{height: "36px"}} arrow placement="top"
                        title={"Если кнопка не активна, добавьте поле. Для добавления или изменения разделителя 1.Введите разделитель, 2.Выберите поле, после которого вставить разделитель, 3.Нажмите добавить"}>
                        <HelpOutlineIcon/>
                    </CustomWidthTooltip>

                </Box>
                <Box sx={{display: "flex", height: "32px", alignItems: "center"}}>
                    {resultData.fields.map((el, i) => {
                        return <>
                            <Chip
                                label={detailField[el]}
                                sx={{
                                    backgroundColor: currentField === i ? "#D7E8FA" : "rgba(0, 0, 0, 0.08)",
                                    "&:hover": {
                                        backgroundColor: currentField === i ? "#D7E8FA" : "rgba(0, 0, 0, 0.08)",
                                    }
                                }}
                                onClick={() => handleClick(i)}
                                onDelete={() => handleDelete(i)}
                            />
                            <Typography sx={{width: "5px"}}>{resultData.separators[i] || " "}</Typography>
                        </>

                    })}</Box>
                {error && <Typography sx={{color: "#d32f2f"}}>Порядок не должен заканчиватся разделителем</Typography>}
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd
                    loading={loading}
                    text={initValue ? "Изменить" : "Добавить"} disabled={resultData.fields.length === 0}
                    onClick={handleAdd}/>
            </DialogActions>
        </Dialog>
    );
}
export default SelcoFileFieldsModal

